<template>
  <div class="model-sidebar">
    <side-bar
      class="sidebar_first"
      :dark="menuMode === 'flowBuilder' || menuMode === 'impactBuilder'"
      @click="onFirstSidebarClick"
    >
      <model-menu v-if="menuMode == 'model'" />

      <scene-node-sidebar 
        v-if="menuMode == 'sceneNode' && selectedItem"
        :scene-node-id="selectedItem.id"
      />

      <target-menu
        v-if="menuMode == 'target' && selectedItem"
        :uid="`target_${selectedItem.id}`"
        :key="`target-menu-${selectedItem.id}`"
        @select="selectSub"
        @deselect="deselectSub"
      />

      <resource-menu
        v-if="menuMode === 'resource' && selectedItem"
        :key="`resource-menu-${selectedItem.id}`"
        :uid="`resource_${selectedItem.id}`"
        :sub-selection="subSelection"
        @select="selectSub"
        @deselect="deselectSub"
        @delete="closeMenu()"
        @close="closeMenu()"
      />

      <index-menu
        v-if="features.index && menuMode == 'index' && selectedItem"
        :key="`index-menu-${selectedItem.id}`"
        :uid="`index_${selectedItem.id}`"
        :sub-selection="subSelection"
        @select="selectSub"
        @deselect="deselectSub"
        @delete="closeMenu()"
        @close="closeMenu()"
      />

      <relation-menu
        v-if="menuMode == 'implicitRelation' && implicitRelation"
        :key="`relation-menu-${implicitRelation.id}`"
        :relation-id="implicitRelation.id"
      />
      <relation-menu
        v-if="menuMode == 'relation' && selectedItem"
        :key="`relation-menu-${selectedItem.id}`"
        :relation-id="selectedItem.id"
      />

      <momentum-menu
        v-if="menuMode == 'momentum' && selectedItem"
        :key="`momentum-menu-${selectedItem.id}`"
        :momentum-id="selectedItem.id"
        @close="closeMenu()"
      />

      <flow-menu
        v-if="menuMode == 'flow' && selectedItem"
        :key="`flow-menu-${selectedItem.id}`"
        :flow-id="selectedItem.id"
        :sub-selection="selectionStore.subSelection"
        @select:branch="selectSub"
        @close="closeMenu()"
      />
      <flow-menu
        v-if="menuMode == 'implicitFlow' && implicitFlow"
        :key="`flow-menu-${implicitFlow.id}`"
        :flow-id="implicitFlow.id"
        :sub-selection="selectionStore.subSelection"
        @select:branch="selectSub"
      />

      <!--
        @delete="deselectMain"
        @select-main="selectMain" -->

      <relation-builder-menu v-if="menuMode == 'impactBuilder'" />
      <flow-builder-menu v-if="menuMode == 'flowBuilder'" />
      <template #after>
        <relation-builder-menu-end v-if="menuMode == 'impactBuilder'" />
        <flow-builder-menu-end v-if="menuMode == 'flowBuilder'" />
      </template>


      <!--
      <menu-group v-if="menuMode == 'relations'">
        {{ $t("messages.multipleRelationsSelected") }}
      </menu-group>
      <menu-group v-if="menuMode == 'targets'">
        <div class="label">
          {{ $t("labels.chosenElements") }}
        </div>
        <button-list :items="validSelectedItems" v-slot="{ item }">
          {{ getItemTitle(item) }}
        </button-list>
      </menu-group>
      <menu-group v-if="menuMode == 'mixed'">
        {{ $t("messages.multipleObjectsSelected") }}
        <div v-for="(items, type) in selectedItemsByType" :key="type">
          <h3 class="label">{{ $t(`objectNames.${type}`, 4) }}</h3>
          <button-list :items="items" v-slot="{ item }">
            {{ getItemTitle(item) }}
          </button-list>
        </div>
      </menu-group> 
      -->
    </side-bar>

    <transition name="menutransition">
      <side-bar v-if="isSecondSidebarOpen" class="sidebar_second">
        <stakeholder-menu
          v-if="selectedStakeholders.length > 0"
          :stakeholder-id="selectedStakeholders[0].id"
          @close="deselectStakeholders()"
        />

        <relation-menu
          v-if="subSelectionItem?.type === 'relation'"
          :relation-id="subSelectionItem?.id"
          @close="deselectSub()"
        />

        <flow-menu
          v-if="subSelectionItem?.type === 'flow'"
          :flow-id="subSelectionItem?.id"
          :key="`flow-menu-${subSelectionItem?.id}`"
          :subSelection="selectionStore.subSubSelection"
          @select:branch="selectSubSub"
          @close="deselectSub()"
        />
        <flow-branch-menu
          v-if="subSelectionItem?.type === 'flowBranch'"
          :flow-branch-id="subSelectionItem?.id"
          :key="`flow-branch-menu-${subSelectionItem?.id}`"
          @close="deselectSub()"
        />

        <momentum-menu
        v-if="subSelectionItem?.type === 'momentum'"
          :key="`momentum-menu-${subSelectionItem?.id}`"
          :momentum-id="subSelectionItem?.id"
          @close="deselectSub()"
        />

        <!-- <resource-influence-menu
          v-if="
            subSelectionItem?.type === 'relation' &&
            subSelectionItem?.endItemType === 'resource'
          "
          :relation-id="subSelectionItem?.id"
          @close="deselectSub()"
        /> -->
      </side-bar>
    </transition>

    <transition name="menutransition">
      <side-bar v-if="isThirdSidebarOpen" class="sidebar_third">
        <flow-branch-menu
          v-if="subSubSelectionItem?.type === 'flowBranch'"
          :flow-branch-id="subSubSelectionItem?.id"
          :key="`flow-branch-menu-${subSubSelectionItem?.id}`"
          @close="deselectSubSub()"
        />
      </side-bar>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { notNull } from "@/helpers/utility/Type";
import { normalizeIdentity } from "@/helpers/utility/Id";

import SideBar from "@core/ui/SideBar.vue";

import RelationBuilderMenu from "@editor/items/relation/RelationBuilderMenu.vue";
import RelationBuilderMenuEnd from "@editor/items/relation/RelationBuilderMenuEnd.vue";
import TargetMenu from "@editor/items/target/TargetMenu.vue";
import IndexMenu from "@editor/items/index/IndexMenu.vue";
import ModelMenu from "@editor/items/model/ModelMenu.vue";
import FlowMenu from "@editor/items/flow/FlowMenu.vue";
import FlowBranchMenu from "@editor/items/flow/FlowBranchMenu.vue";
import RelationMenu from "@editor/items/relation/RelationMenu.vue";
import MomentumMenu from "@editor/items/momentum/MomentumMenu.vue";
import ResourceMenu from "@editor/items/resource/ResourceMenu.vue";
import StakeholderMenu from "@editor/items/stakeholder/StakeholderMenu.vue";
import FlowBuilderMenu from "@editor/items/flow/FlowBuilderMenu.vue";
import FlowBuilderMenuEnd from "@editor/items/flow/FlowBuilderMenuEnd.vue";
import SceneNodeSidebar from "@editor/items/scene/SceneNodeSidebar.vue";

import { useSelectionStore } from "@editor/store/editor/selection.store";
import { useRelationStore } from "@editor/items/relation/relations.store";
import { useStakeholderStore } from "@editor/items/stakeholder/stakeholders.store";
import { useTargetStore } from "@editor/items/target/targets.store";
import { useModelStore } from "@editor/items/model/model.store";
import { useResourceStore } from "@editor/items/resource/resources.store";
import { useFeatures, useFeatureStore } from "@editor/store/features.store";
import { useFlowStore } from "@editor/items/flow/flows.store";
import { useModelViewStore } from "./modelView.store";
import { useFlowBranchStore } from "@editor/items/flow/flowBranches.store";
import { useSceneNodesStore } from "@editor/items/scene/sceneNodes.store";

import type { Handleable } from "@core/types/Events";
import { isSceneElementNode } from "@editor/items/sceneElement/sceneElementFunctions";
import { useElements } from "@editor/items/element/elements";

defineOptions({
  name: "ModelSidebar"
});

const props = defineProps<{}>();

const features = useFeatures();
const modelStore = useModelStore();
const selectionStore = useSelectionStore();
const modelViewStore = useModelViewStore();
const flowStore = useFlowStore();
const flowBranchStore = useFlowBranchStore();
const sceneNodeStore = useSceneNodesStore();
const elements = useElements();

const impactSourceElement = computed(() => modelViewStore.impactSourceElement);
const flowSourceElement = computed(() => modelViewStore.flowSourceElement);
const selectedItem = computed(() => selectionStore.selectedItem);
const subSelection = computed(() => selectionStore.subSelection);


/**
 * Filter out any non-existing items:
 */
const selectedItems = computed(() => {
  const selection = useSelectionStore().selectedItems;

  return selection
    .map((item) =>
      item.type == "question"
        ? item
        : useModelStore().getItem(item.type, item.id)
    )
    .filter(notNull);
});

/**
 * Only return the selected item if it exists:
 */
const resolvedSelectedItem = computed(() => {
  const selection = useSelectionStore().selectedItem;
  if (!selection) return null;
  if (selection.type == "question") return selection;
  return useModelStore().getItem(selection.type, selection.id);
});

const activeMenu = computed(() => {
  const selection = selectedItems.value;
  const selectedItem = resolvedSelectedItem.value;
  
  // if there are fixed elements, these have priority
  const impactSourceElement = modelViewStore.impactSourceElement;
  if (impactSourceElement) {
    const { type } = normalizeIdentity(impactSourceElement);
    switch (type) {
      case "target":
      case "resource":
      case "index":
        if (selectedItem?.type === "relation") {
          return "relation";
        }
        return "impactBuilder";

      default:
        console.log("No menu for selected element.");
        return "error";
    }
  }

  const flowSourceElement = modelViewStore.flowSourceElement;
  if (flowSourceElement) {
    const { type } = normalizeIdentity(flowSourceElement);
    switch (type) {
      case "target":
      case "resource":
        if (selectedItem?.type === "flow") {
          return "flow";
        }
        return "flowBuilder";

      default:
        console.log("No menu for selected element.");
        return "error";
    }
  }

  // no items selected? Default menu.
  if (selection.length === 0) {
    return "model";
  }

  if (selection.length === 1 && selectedItem) {
    if (selectedItem.type === "area") return "model";
    if (selectedItem.type === "question") return "model";
    if (selectedItem.type === "relation") return "relation";
    if (selectedItem.type === "flow") return "flow";
    if (selectedItem.type === "flowBranch") return "flowBranch";
    if (selectedItem.type === "sceneNode") return "sceneNode";

    if (!useFeatureStore().enabled(selectedItem.type)) {
      return "model";
    }

    return selectedItem.type;
  }

  if (selection.length > 1) {
    return "model";
  }

  return undefined;
});

const subSelectionItem = computed(() => {
  if (!selectionStore.subSelection) return null;
  return modelStore.getItem(
    selectionStore.subSelection.type,
    selectionStore.subSelection.id
  );
});

const subSubSelectionItem = computed(() => {
  if (!selectionStore.subSubSelection) return null;
  return modelStore.getItem(
    selectionStore.subSubSelection.type,
    selectionStore.subSubSelection.id
  );
});

// const validSelectedItems = computed(() => {
//   return selectionStore.selectedItems.reduce(
//     (valid, selection) => {
//       if (selection.type === "question") return valid;
//       const item = modelStore.getItem(selection.type, selection.id);
//       if (item) valid.push(item);
//       return valid;
//     },
//     [] as (
//       | TargetItem
//       | AreaItem
//       | MomentumItem
//       | RelationItem
//       | FlowItem
//       | FlowBranchItem
//       | ResourceItem
//       | IndexItem
//       | SceneNodeItem
//     )[]
//   );
// });

const selectedElements = computed(() => {
  const resourceIds = selectionStore.selected.resource;
  const targetIds = selectionStore.selected.target;
  const resources = useResourceStore().getArrayByIds(resourceIds);
  const targets = useTargetStore().getArrayByIds(targetIds);
  const nodeIds = selectionStore.selected.sceneNode;
  const elementNodes = sceneNodeStore.getArrayByIds(nodeIds).filter(isSceneElementNode);
  const nodeElements = elementNodes.map((node) => elements.byUid[node.data.elementUid]).filter(notNull).filter((el) => el.type != "index");
  return [...resources, ...targets, ...nodeElements];
});

const selectedStakeholders = computed(() => {
  const stakeholderStore = useStakeholderStore();
  return selectionStore.selectedStakeholderIds
    .map((stakeholderId) => stakeholderStore.items[stakeholderId])
    .filter((s) => s != null);
});

const menuMode = computed(() => {
  if (implicitFlow.value != null) return "implicitFlow";
  if (implicitRelation.value != null) return "implicitRelation";
  return activeMenu.value || "model";
});

const implicitRelation = computed(() => {
  if (!impactSourceElement.value) return null;
  if (selectedElements.value.length != 1) return null;

  const selectedItem = selectedElements.value[0];

  const relationStore = useRelationStore();
  const { type, id } = normalizeIdentity(impactSourceElement.value);

  return (
    relationStore.orderedItems.find(
      (relation) =>
        type == relation.startItemType &&
        id === relation.startItemId &&
        selectedItem.type == relation.endItemType &&
        selectedItem.id === relation.endItemId
    ) ?? null
  );
});

const implicitFlow = computed(() => {
  if (activeMenu.value == "flowBranch") {
    if (!selectedItem.value) return null;
    return flowStore.items[flowBranchStore.items[selectedItem.value?.id].flowId];
  }

  if (!flowSourceElement.value) return null;
  if (selectedElements.value.length != 1) return null;

  const selectedElement = selectedElements.value[0];

  const { type: flowSourceType, id: flowSourceId } = normalizeIdentity(flowSourceElement.value);
  
  const startBranches = flowBranchStore.orderedItems.filter((flowBranch) => flowBranch.branchType == "source" && flowBranch.elementType == flowSourceType && flowBranch.elementId == flowSourceId);
  const endBranches = flowBranchStore.orderedItems.filter((flowBranch) =>  flowBranch.branchType == "sink" && flowBranch.elementType == selectedElement.type && flowBranch.elementId == selectedElement.id);

  const correctStartBranch = startBranches.find((startBranch) => endBranches.find((endBranch) => endBranch.flowId == startBranch.flowId));
  if (correctStartBranch) {
    return flowStore.items[correctStartBranch.flowId];
  }
  return null;
});

const isSecondSidebarOpen = computed(() => {
  if (selectedStakeholders.value.length > 0) return true;
  if (selectionStore.subSelection != null) return true;
  return false;
});

const isThirdSidebarOpen = computed(() => {
  if (selectionStore.subSubSelection != null) return true;
  return false;
});

// ====================
// Methods

const selectSub = selectionStore.selectSub;
const selectSubSub = selectionStore.selectSubSub;

function onFirstSidebarClick(pointerEvent: PointerEvent & Handleable) {
  if (pointerEvent.hasBeenHandled || pointerEvent.defaultPrevented) {
    return;
  }
  selectionStore.selectSub(null);
}

function closeMenu() {
  selectionStore.clearAll();
}

function deselectSub() {
  selectionStore.selectSub(null);
}
function deselectSubSub() {
  selectionStore.selectSubSub(null);
}

function deselectStakeholders() {
  return selectionStore.deselectStakeholders();
}
</script>

<style lang="scss">
.model-sidebar {
  position: relative;
  z-index: 1;
}
</style>
